<h1 mat-dialog-title>
  {{ 'ALREADY_IN_USE' | translate }}
  <button
    [mat-dialog-close]="false"
    aria-label="close"
    mat-icon-button
  >
    <mat-icon>close</mat-icon>
  </button>
</h1>

<div mat-dialog-content>
  {{ 'WORK_ORDER_IN_USE_BY' | translate }} <strong>{{ data.userName }}</strong>
  <br />
  {{ 'ARE_YOU_SURE_YOU_WANT_TO_CLAIM_IT' | translate }}
</div>

<div mat-dialog-actions>
  <button
    [mat-dialog-close]="false"
    mat-button
    data-testid="lock-work-order-warning-dialog-cancel"
  >
    {{ "CANCEL" | translate }}
  </button>
  <button
    [mat-dialog-close]="true"
    cdkFocusInitial
    class="rs-btn--primary"
    mat-button
    data-testid="lock-work-order-warning-dialog-confirm"
  >
    {{ 'OK' | translate }}
  </button>
</div>